import { useState, useEffect, useMemo } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { getLogo } from '../services/marketDataService';
import localLogos from '../constants/localLogos.json';

const LOGO_CACHE_KEY = 'investport_stock_logos_v2';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const KNOWN_LOGOS = {
  // === Popular ETFs & Indices ===
  'US500': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://spglobal.com&size=128',
  'SPX': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://spglobal.com&size=128',
  'NAS100': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://nasdaq.com&size=128',
  'NDX': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://nasdaq.com&size=128',
  'DJI': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://spglobal.com&size=128',
  'VIX': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://cboe.com&size=128',
  'RUT': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ftserussell.com&size=128',
  'SET': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://set.or.th&size=128',
  'WTI': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='14' fill='%231e293b'/%3E%3Cpath d='M32 16C32 16 20 32 20 42C20 48.6274 25.3726 54 32 54C38.6274 54 44 48.6274 44 42C44 32 32 16 32 16Z' fill='%230ea5e9'/%3E%3C/svg%3E",
  'BRENT': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='14' fill='%231e293b'/%3E%3Cpath d='M32 16C32 16 20 32 20 42C20 48.6274 25.3726 54 32 54C38.6274 54 44 48.6274 44 42C44 32 32 16 32 16Z' fill='%230ea5e9'/%3E%3C/svg%3E",
  'SILVER': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cdefs%3E%3ClinearGradient id='silv' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%23e2e8f0'/%3E%3Cstop offset='100%25' stop-color='%2394a3b8'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='32' cy='32' r='30' fill='url(%23silv)'/%3E%3Ctext x='32' y='36' text-anchor='middle' fill='%23334155' font-size='14' font-weight='bold' font-family='Arial'%3EAG%3C/text%3E%3C/svg%3E",
  'SPY': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ssga.com&size=128',
  'VOO': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'VTI': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'QQQ': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://invesco.com&size=128',
  'QQQM': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://invesco.com&size=128',
  'DIA': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ssga.com&size=128',
  'IVV': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'ARKK': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ark-funds.com&size=128',
  'VT': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'VIG': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'IEFA': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'AGG': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'BND': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'GLD': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://spdrgoldshares.com&size=128',
  'IAU': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'SLV': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'SCHD': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://schwab.com&size=128',
  'VYM': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'VEA': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'VWO': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'TQQQ': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://proshares.com&size=128',
  'SQQQ': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://proshares.com&size=128',
  'IWM': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://ishares.com&size=128',
  'VNQ': 'https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://vanguard.com&size=128',
  'QQQI': 'https://financialmodelingprep.com/image-stock/QQQI.png',
  'SPYI': 'https://financialmodelingprep.com/image-stock/SPYI.png',
  'SGOV': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='14' fill='%23006fba'/%3E%3Ccircle cx='32' cy='17' r='4' fill='white'/%3E%3Crect x='28' y='25' width='8' height='26' rx='2' fill='white'/%3E%3C/svg%3E",
  'IVV': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='14' fill='%23006fba'/%3E%3Ccircle cx='32' cy='17' r='4' fill='white'/%3E%3Crect x='28' y='25' width='8' height='26' rx='2' fill='white'/%3E%3C/svg%3E",
  'SMH': 'https://financialmodelingprep.com/image-stock/SMH.png',
  // === Popular Stocks (Pre-fetched from Finnhub API & FMP) ===
  'MSFT': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/MSFT.png',
  'AAPL': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/AAPL.png',
  'NVDA': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/NVDA.png',
  'AMZN': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/AMZN.png',
  'META': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/FB.png', // Meta uses FB.png on Finnhub
  'GOOGL': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Crect width='48' height='48' rx='10' fill='white'/%3E%3Cg transform='translate(8, 8) scale(0.6666)'%3E%3Cpath fill='%234285F4' d='M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z'/%3E%3Cpath fill='%2334A853' d='M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z'/%3E%3Cpath fill='%23FBBC05' d='M11.69 28.18c-.44-1.31-.69-2.72-.69-4.18s.25-2.87.69-4.18v-5.7H4.34C1.58 17.5 0 20.65 0 24s1.58 6.5 4.34 9.88l7.35-5.7z'/%3E%3Cpath fill='%23EA4335' d='M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.14 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z'/%3E%3C/g%3E%3C/svg%3E",
  'GOOG': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'%3E%3Crect width='48' height='48' rx='10' fill='white'/%3E%3Cg transform='translate(8, 8) scale(0.6666)'%3E%3Cpath fill='%234285F4' d='M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z'/%3E%3Cpath fill='%2334A853' d='M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z'/%3E%3Cpath fill='%23FBBC05' d='M11.69 28.18c-.44-1.31-.69-2.72-.69-4.18s.25-2.87.69-4.18v-5.7H4.34C1.58 17.5 0 20.65 0 24s1.58 6.5 4.34 9.88l7.35-5.7z'/%3E%3Cpath fill='%23EA4335' d='M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.14 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z'/%3E%3C/g%3E%3C/svg%3E",
  'TSLA': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/TSLA.png',
  'NFLX': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/NFLX.png',
  'AMD': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/AMD.png',
  'ORCL': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/ORCL.png',
  'V': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/V.png',
  'CRWD': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/CRWD.png',
  'RBRK': 'https://static2.finnhub.io/file/publicdatany/finnhubimage/stock_logo/950458187056.png', // Rubrik's exact Finnhub ID
  // === Missing / Small-cap Stocks (not on Twelve Data logo API) ===
  'AXON': 'https://financialmodelingprep.com/image-stock/AXON.png',
  'OKLO': 'https://financialmodelingprep.com/image-stock/OKLO.png',
  'ALAB': 'https://financialmodelingprep.com/image-stock/ALAB.png',
  'AVAV': 'https://financialmodelingprep.com/image-stock/AVAV.png',
  'NBIS': 'https://financialmodelingprep.com/image-stock/NBIS.png',
  'CRWV': 'https://financialmodelingprep.com/image-stock/CRWV.png',
  'ONDS': 'https://financialmodelingprep.com/image-stock/ONDS.png',
  'IREN': 'https://financialmodelingprep.com/image-stock/IREN.png',
  'EOSE': 'https://financialmodelingprep.com/image-stock/EOSE.png',
  'TSM': 'https://financialmodelingprep.com/image-stock/TSM.png',
  // === Crypto ===
  'BTC': 'https://financialmodelingprep.com/image-stock/BTCUSD.png',
  'BTCUSD': 'https://financialmodelingprep.com/image-stock/BTCUSD.png',
  'ETH': 'https://financialmodelingprep.com/image-stock/ETHUSD.png',
  'ETHUSD': 'https://financialmodelingprep.com/image-stock/ETHUSD.png',
  'USDT': 'https://financialmodelingprep.com/image-stock/USDTUSD.png',
  'BNB': 'https://financialmodelingprep.com/image-stock/BNBUSD.png',
  'SOL': 'https://financialmodelingprep.com/image-stock/SOLUSD.png',
  'XRP': 'https://financialmodelingprep.com/image-stock/XRPUSD.png',
  'ADA': 'https://financialmodelingprep.com/image-stock/ADAUSD.png',
  'DOGE': 'https://financialmodelingprep.com/image-stock/DOGEUSD.png',
  'DOT': 'https://financialmodelingprep.com/image-stock/DOTUSD.png',
  'MATIC': 'https://financialmodelingprep.com/image-stock/MATICUSD.png',
  'SHIB': 'https://financialmodelingprep.com/image-stock/SHIBUSD.png',
  'LINK': 'https://financialmodelingprep.com/image-stock/LINKUSD.png',
  // === Gold & Precious Metals ===
  'XAUUSD': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cdefs%3E%3ClinearGradient id='g1' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%23fbbf24'/%3E%3Cstop offset='100%25' stop-color='%23d97706'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='32' cy='32' r='30' fill='url(%23g1)'/%3E%3Ctext x='32' y='24' text-anchor='middle' fill='white' font-size='10' font-weight='bold' font-family='Arial'%3EXAU%3C/text%3E%3Ctext x='32' y='36' text-anchor='middle' fill='white' font-size='10' font-weight='bold' font-family='Arial'%3EUSD%3C/text%3E%3Ctext x='32' y='50' text-anchor='middle' fill='%23fef3c7' font-size='8' font-family='Arial'%3E%F0%9F%A5%87%3C/text%3E%3C/svg%3E",
  'GOLDTHB': "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cdefs%3E%3ClinearGradient id='g2' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0%25' stop-color='%23fbbf24'/%3E%3Cstop offset='100%25' stop-color='%23b45309'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='32' cy='32' r='30' fill='url(%23g2)'/%3E%3Ctext x='32' y='22' text-anchor='middle' fill='white' font-size='8' font-weight='bold' font-family='Arial'%3EGOLD%3C/text%3E%3Ctext x='32' y='34' text-anchor='middle' fill='white' font-size='10' font-weight='bold' font-family='Arial'%3ETHB%3C/text%3E%3Ctext x='32' y='50' text-anchor='middle' fill='%23fef3c7' font-size='8' font-family='Arial'%3E%F0%9F%87%B9%F0%9F%87%AD%3C/text%3E%3C/svg%3E",
};

export function useStockLogos(holdings, watchlists = []) {
  const [logos, setLogos] = useState({});
  const [loading, setLoading] = useState(false);

  // Extract watchlist symbols to include in logo fetching
  const watchlistSymbolsKey = useMemo(() => {
    if (!watchlists || watchlists.length === 0) return '';
    const syms = [];
    watchlists.forEach(list => {
      if (list.symbols && Array.isArray(list.symbols)) {
        syms.push(...list.symbols);
      }
    });
    return [...new Set(syms)].sort().join(',');
  }, [watchlists]);

  useEffect(() => {
    // 1. Get unique symbols from holdings (both active and realized) + watchlists
    const holdingSymbols = holdings.filter(h => h.quantity > 0 || h.realizedPnLUSD !== 0).map(h => h.symbol);
    const watchlistSymbols = watchlistSymbolsKey ? watchlistSymbolsKey.split(',') : [];
    const activeSymbols = [...new Set([...holdingSymbols, ...watchlistSymbols])];
    if (activeSymbols.length === 0) return;

    // 2. Load existing cache
    let cachedLogos = {};
    try {
      const stored = localStorage.getItem(LOGO_CACHE_KEY);
      if (stored) cachedLogos = JSON.parse(stored);
    } catch (e) {
      console.error('Error reading logo cache', e);
    }

    // Track which symbols had NO resolved logo before we seed defaults below.
    // Only these need the (slower) async Twelve Data / Firestore upgrade.
    const originallyUnresolved = new Set(
      activeSymbols.filter(sym => !(sym in cachedLogos) || cachedLogos[sym] == null)
    );

    // 3. Seed a deterministic best-effort logo URL for EVERY active symbol so
    //    a real logo is available IMMEDIATELY — even on a fresh origin with an
    //    empty localStorage (the built/deployed app). Previously the deployed
    //    app showed no logo while localhost did, simply because localhost had
    //    already populated its cache.
    let cacheNeedsUpdate = false;
    activeSymbols.forEach(sym => {
      const clean = sym.split('-')[0].toUpperCase();
      let best;
      if (localLogos.includes(clean)) {
        best = `/logos/${clean}.png`;            // bundled offline logo
      } else if (KNOWN_LOGOS[clean]) {
        best = KNOWN_LOGOS[clean];               // curated URL / inline SVG
      } else if (!cachedLogos[sym]) {
        // No cached value yet → deterministic CDN fallback that needs no cache
        best = `https://financialmodelingprep.com/image-stock/${clean}.png`;
      }
      if (best && cachedLogos[sym] !== best) {
        cachedLogos[sym] = best;
        cacheNeedsUpdate = true;
      }
    });

    setLogos({ ...cachedLogos });
    if (cacheNeedsUpdate) {
      try { localStorage.setItem(LOGO_CACHE_KEY, JSON.stringify(cachedLogos)); } catch (e) {}
    }

    // 4. Async-upgrade only brand-new symbols (not local, not curated) to a
    //    higher-quality Twelve Data / global-cache logo. They already show the
    //    FMP fallback in the meantime, so the UI is never empty.
    const missingSymbols = activeSymbols.filter(sym => {
      const clean = sym.split('-')[0].toUpperCase();
      if (localLogos.includes(clean) || KNOWN_LOGOS[clean]) return false;
      return originallyUnresolved.has(sym);
    });
    if (missingSymbols.length === 0) return; // Everything resolved already!

    // 5. Fetch missing symbols sequentially to avoid rate limits
    let isMounted = true;
    
    const fetchMissingLogos = async () => {
      setLoading(true);
      // Wait 1.5 seconds before starting to not clash with initial price load from useCurrentPrices
      await delay(1500);
      
      let updatedLogos = { ...cachedLogos };
      let newLogosFetched = false;

      for (const symbol of missingSymbols) {
        if (!isMounted) break;

        // 1. Bypass check for ETFs & Crypto & Local CDN
        const cleanSymbol = symbol.split('-')[0].toUpperCase();
        
        // CHECK CDN FIRST
        if (localLogos.includes(cleanSymbol)) {
          updatedLogos[symbol] = `/logos/${cleanSymbol}.png`;
          newLogosFetched = true;
          if (isMounted) setLogos({ ...updatedLogos });
          continue; // Instantly skip API call!
        }

        if (KNOWN_LOGOS[cleanSymbol]) {
          updatedLogos[symbol] = KNOWN_LOGOS[cleanSymbol];
          newLogosFetched = true;
          if (isMounted) setLogos({ ...updatedLogos });
          continue; // Instantly skip Finnhub call
        }

        try {
          // 1.5. Check Global Firestore Cache FIRST
          try {
            const logoDocRef = doc(db, 'global_logos', cleanSymbol);
            const logoDocSnap = await getDoc(logoDocRef);
            if (logoDocSnap.exists()) {
              const cachedLogo = logoDocSnap.data().logoUrl;
              // If previously marked as NO_LOGO, fall back to the FMP image URL
              // (a deterministic best-effort) instead of showing nothing.
              updatedLogos[symbol] = (cachedLogo && cachedLogo !== 'NO_LOGO')
                ? cachedLogo
                : `https://financialmodelingprep.com/image-stock/${cleanSymbol}.png`;
              newLogosFetched = true;
              if (isMounted) setLogos({ ...updatedLogos });
              continue; // Move to next symbol!
            }
          } catch(e) { console.error('Firestore global cache read error', e); }

          // 2. Fallback to fetch from proxy for stocks
          let finalLogo = null;
          
          try {
            const data = await getLogo(cleanSymbol);
            // Twelve Data returns { url: 'https://...' } or an error object
            finalLogo = data?.url || null; 
            
            // Auto-Fallback for missing logos (Great for ETFs)
            if (!finalLogo) {
               finalLogo = `https://financialmodelingprep.com/image-stock/${cleanSymbol}.png`;
            }
          } catch (profileErr) {
            if (profileErr.message && profileErr.message.includes('429')) {
              console.warn(`Rate limit hit fetching logo for ${symbol}`);
              await delay(2000);
              continue;
            }
          }

          // Never leave a symbol without a logo URL — default to FMP.
          if (!finalLogo) {
            finalLogo = `https://financialmodelingprep.com/image-stock/${cleanSymbol}.png`;
          }
          updatedLogos[symbol] = finalLogo;
          newLogosFetched = true;
          
          // Update partial state immediately so UI updates as logos load
          if (isMounted) setLogos({ ...updatedLogos });

          // 3. Store the result back into global Firestore cache
          try {
            const logoDocRef = doc(db, 'global_logos', cleanSymbol);
            await setDoc(logoDocRef, {
              logoUrl: finalLogo || 'NO_LOGO',
              updatedAt: new Date().toISOString()
            });
          } catch(e) { console.error('Firestore global cache write error', e); }

          // Small delay to prevent burst limit issues
          await delay(350);

        } catch (e) {
          console.error(`Error fetching logo for ${symbol}`, e);
        }
      }

      if (isMounted && newLogosFetched) {
        setLogos(updatedLogos);
        try {
          localStorage.setItem(LOGO_CACHE_KEY, JSON.stringify(updatedLogos));
        } catch (e) {
          console.error('Failed to save logos to cache', e);
        }
      }
      if (isMounted) setLoading(false);
    };

    fetchMissingLogos();

    return () => {
      isMounted = false;
    };
  }, [holdings.length, watchlistSymbolsKey]); // Re-trigger when new stocks are added to holdings or watchlists

  return { logos, loadingLogos: loading };
}
